export default function byRegexp(regex, processMatch) {
    if (!regex.global) {
        throw new Error('RegExp must have a global flag!');
    }
    return function (text) {
        regex.lastIndex = 0;
        const founds = [];
        while (true) {
            const match = regex.exec(text);
            if (match === null) {
                break;
            }
            const it = processMatch(match.index, match[0], match);
            it && founds.push(it);
        }
        return founds;
    };
}
export function makeToken(Constr) {
    return (offset, text) => new Constr(offset, text);
}
//# sourceMappingURL=byRegexp.js.map